import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'documents-contracts',
    name: 'Documents & Contracts Management',
    description: 'Contract lifecycle, document control and signature.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'documents',
    features: [
        { key: 'documents_contracts.e_signature', description: 'Electronic signature workflow' },
        { key: 'documents_contracts.clause_library', description: 'Reusable approved clause library' },
    ],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] },
        {
            code: 'ed_02',
            description: 'Adds signature and the clause library',
            features: ['documents_contracts.e_signature', 'documents_contracts.clause_library'],
            limits: ['user', 'active_user', 'transaction'],
        },
    ],
    limitTypes: ['user', 'active_user', 'transaction'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'storage',
        'attachments',
        'party_master',
        'compliance_kernel',
    ],
    optionalModules: ['crm', 'finance'],
    integrationDeps: ['e-signature'],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map